import jq from 'jquery';
import LocalTracking from '@shared/tracking-local';

export function addError(selector, msg) {
  const id = jq(selector).attr('id');
  if (isError(selector)) {
    if (jq(selector).hasClass('inline-error')) {
      jq(selector).next('.ns_error').html(msg);
      return;
    }

    jq(`#error_${id}`).html(
      `<p>${msg}` +
        '</p><span class="ns_arrow"></span><span class="ns_icon"></span>',
    );
    return;
  }
  jq(selector).addClass('ns_error');

  jq(`label[for="${id}"]`).addClass('ns_error');
  if (jq(selector).hasClass('inline-error')) {
    jq(`<span class="ns_error ns_left">${msg}</span>`).insertAfter(selector);
    return;
  }
  jq('#ns_sidebar').append(
    `<div id="error_${id}" class="ns_bubble ns_error">
        <p>${msg}</p>
        <span class="ns_arrow"></span>
        <span class="ns_icon"></span>
      </div>`,
  );

  // fetch the absolute position of the screen / browser window
  let offset = jq(selector).offset();
  const y = parseInt(offset.top, 10);
  offset = jq(`#error_${id}`).offset();
  const x = parseInt(offset.left, 10);
  // set the absolute position of the screen / browser window
  jq(`#error_${id}`).offset({ top: y - 4, left: x });
  jq(`#error_${id}`).hide();
  jq(`#error_${id}`).fadeIn('slow');
  hideTooltip();
}

export function displayErrorMessage(params) {
  if (typeof params !== 'object') {
    throw 'Invalid parameter';
  }

  if (typeof params.element === 'undefined') {
    throw 'Element is required';
  }

  let options = {
    errorContainer: jq(params.element)
      .parent('.control-group')
      .find('.help-block'),
    errorMessage: 'Invalid value.',
  };

  options = jq.extend(options, params);

  jq(options.element).parent('.control-group').addClass('error');
  jq(options.errorContainer).text(options.errorMessage);
}

export function discardErrorMessage(params) {
  if (typeof params !== 'object') {
    throw 'Invalid parameter';
  }

  if (typeof params.element === 'undefined') {
    throw 'Element is required';
  }

  let options = {
    errorContainer: jq(params.element)
      .parent('.control-group')
      .find('.help-block'),
  };

  options = jq.extend(options, params);

  jq(options.element).parent('.control-group').removeClass('error');
  jq(options.errorContainer).text('');
}

/**
* Add error with the absolute position refer to a nominated html element,
* suitable for all browsers.
* @param selector html selector
* @param direction {'top', 'right', 'left', bottom'}
* @param msg error message
* @param posref_selector a selector of which the position should be referred
*                        to, default is @param selector if not provided
* @param additional
* @return bool
*/
export function addAbPosError(
  selector,
  direction,
  msg,
  posrefSelector,
  additional,
) {
  if (isError(selector)) {
    return true;
  }
  if (
    !(direction == 'top' ||
      direction == 'bottom' ||
      direction == 'left' ||
      direction == 'right')
  ) {
    return false;
  }

  jq(selector).addClass('ns_error');
  const ref = posrefSelector || selector;
  const refPos = {
    left: parseInt(jq(ref).offset().left, 10),
    top: parseInt(jq(ref).offset().top, 10),
    width: parseInt(jq(ref).css('width'), 10),
    height: parseInt(jq(ref).css('height'), 10),
  };
  const err = jq('<span></span>')
    .addClass('ns_error')
    .css('position', 'absolute')
    .attr('selector', selector)
    .html(msg);

  if (additional && additional.width) {
    err.css('width', additional.width);
  }
  err.insertAfter(ref);
  switch (direction) {
    case 'right':
      err
        .offset({
          top: refPos.top + (additional ? additional.top : 0),
          left: refPos.left + refPos.width + (additional ? additional.left : 0),
        })
        .show();
      break;
    case 'bottom':
      err
        .offset({
          top: refPos.top + refPos.height + (additional ? additional.top : 0),
          left: refPos.left + (additional ? additional.left : 0),
        })
        .show();
      break;
    default:
    // do nothing
  }
}

export function removeAbPosError(selector) {
  if (isError(selector)) {
    jq(selector).removeClass('ns_error');
    jq(`.ns_error[selector=${selector}]`).remove();
  }
}

/**
* This function only add error message to the same line of the given element
* If you want to apply error to the element use: addError()
* @param selector
* @param id
* @param msg
*/
export function addErrorMsg(selector, id, msg) {
  if (jq(`#error_${id}`).length !== 0) {
    jq(`#error_${id}`).html(
      `<p>${msg}</p>
        <span class="ns_arrow"></span>
        <span class="ns_icon"></span>`,
    );
    return;
  }
  jq('#ns_sidebar').append(
    `<div id="error_${id}" class="ns_bubble ns_error">
        <p>${msg}</p>
        <span class="ns_arrow"></span>
        <span class="ns_icon"></span>
      </div>`,
  );

  // fetch the absolute position of the screen / browser window
  let offset = jq(selector).offset();
  const y = parseInt(offset.top, 10);
  offset = jq(`#error_${id}`).offset();
  const x = parseInt(offset.left, 10);
  // set the absolute position of the screen / browser window
  jq(`#error_${id}`).offset({ top: y - 4, left: x });
  jq(`#error_${id}`).hide();
  jq(`#error_${id}`).fadeIn('slow');
}

export function removeError(selector, hideTips) {
  if (isError(selector)) {
    const id = jq(selector).attr('id');
    if (jq(selector).hasClass('inline-error')) {
      jq(selector).next('.ns_error').remove();
    }

    jq(`#error_${id}`).fadeOut('slow', () => {
      jq(`#error_${id}`).remove();
    });
    jq(`#${id}`).removeClass('ns_error');
    jq(`label[for="${id}"]`).removeClass('ns_error');
    if (hideTips === null) {
      showTooltip();
    }
  }
}
export function removeErrorMessage(selector, hideTips) {
  if (isError(selector)) {
    const id = jq(selector).attr('id');
    if (jq(selector).hasClass('inline-error')) {
      jq(selector).next('.ns_error').remove();
    }

    // jq(`#error_${id}`).fadeOut('slow', function() {
    jq(`#error_${id}`).remove();
    // });
    jq(`#${id}`).removeClass('ns_error');
    jq(`label[for="${id}"]`).removeClass('ns_error');
    if (hideTips === null) {
      showTooltip();
    }
  }
}

/**
* This will only remove the error message bubble
* If you want to remove error from the element use: removeError()
* @param id int id of the error message
*/
export function removeErrorMsg(id) {
  jq(`#error_${id}`).fadeOut('slow', () => {
    jq(`#error_${id}`).remove();
  });
}

export function removeAllErrors() {
  jq('.ns_bubble.ns_error').remove();
  jq('.ns_error').each(function () {
    jq(this).removeClass('ns_error');
  });
}

export function isError(selector) {
  return jq(selector).hasClass('ns_error');
}

export function syncErrorPosition(selector) {
  const id = jq(selector).attr('id');
  // fetch the absolute position of the screen / browser window
  let offset = jq(selector).offset();
  const y = parseInt(offset.top, 10);
  offset = jq(`#error_${id}`).offset();
  const x = parseInt(offset.left, 10);
  // set the absolute position of the screen / browser window
  jq(`#error_${id}`).offset({ top: y - 4, left: x });
}

export function switchWizard(selector, totalState, index) {
  for (let i = 1; i <= totalState; ++i) {
    jq(selector).removeClass(`ns_wizard-${totalState}-state-${i}`);
  }
  jq(selector).addClass(`ns_wizard-${totalState}-state-${index}`);
  for (let i = 1; i <= totalState; ++i) {
    jq(`ul li:nth-child(${i}) a`).removeClass('ns_wizard-selected');
  }
  jq(`ul li:nth-child(${index}) a`).addClass('ns_wizard-selected');
}

export function updateCheck(selector) {
  if (jq(selector).is(':checked')) {
    addCheck(selector);
  } else {
    removeCheck(selector);
  }
}

export function addCheck(selector) {
  jq(selector).parents('li').addClass('ns_selected');
}

export function removeCheck(selector) {
  jq(selector).parents('li').removeClass('ns_selected');
}

export function displayTooltip(selector, msg) {
  jq('#form_tooltip').fadeOut('fast', () => {
    // fetch the absolute position of the screen / browser window
    let offset = jq(selector).offset();
    const y = parseInt(offset.top, 10);
    // in order to get position correctly tooltip must be rendered
    jq('#form_tooltip').show();
    offset = jq('#form_tooltip').offset();
    const x = parseInt(offset.left, 10);
    // set the absolute position of the screen / browser window
    jq('#form_tooltip').offset({ top: y - 4, left: x });
    jq('#form_tooltip').hide();
    jq('#form_tooltip > p').html(msg);
    if (isError(selector)) {
      hideTooltip();
    } else {
      showTooltip();
    }
  });
}

export function hideTooltip() {
  jq('#form_tooltip').fadeOut('fast');
}

export function showTooltip() {
  jq('#form_tooltip').fadeIn('slow');
}

export function syncTooltipPosition(selector) {
  // fetch the absolute position of the screen / browser window
  let offset = jq(selector).offset();
  const y = parseInt(offset.top, 10);
  offset = jq('#form_tooltip').offset();
  const x = parseInt(offset.left, 10);
  // set the absolute position of the screen / browser window
  jq('#form_tooltip').offset({ top: y - 4, left: x });
}

export function checkCharacterLimit(inputBox, counterSpan, limit, truncate) {
  const str = jq(inputBox).val();
  let count = str.length;
  if (count > limit) {
    if (truncate) {
      count = limit;
      jq(inputBox).val(str.substr(0, limit));
    }
  }
  jq(counterSpan).html(limit - count);
  if (count > limit) {
    return false;
  }
  return true;
}

jq(document).on('click', 'ul.ns_checkbox-big > li', function (event) {
  if (
    event.target.type !== 'checkbox' &&
    event.target.type !== 'radio' &&
    event.target.tagName !== 'LABEL'
  ) {
    jq('input', this).trigger('click');
    jq('input', this).trigger('change');
  }
});

jq(document).on('click', 'ul.ns_radio-btn > li', function (event) {
  if (
    event.target.type !== 'checkbox' &&
    event.target.type !== 'radio' &&
    event.target.tagName !== 'LABEL'
  ) {
    jq('input', this).trigger('click');
    jq('input', this).trigger('change');
  }
});

jq(document).on('change', '.ns_radio-btn input[type=radio]', function () {
  jq(`.ns_radio-btn input[name=${jq(this).attr('name')}]`)
    .parents('li')
    .removeClass('ns_selected');
  jq(this).parents('li').addClass('ns_selected');
});

jq(document).ready(() => {
  jq('.ns_radio-btn input[type=radio]:checked')
    .parents('li')
    .addClass('ns_selected');

  jq('#login-normal').click(() => {
    const tt = jq('iframe#login-frame').contents();
    const bbutton = jq('#login_btn', tt);
    jq(bbutton).click(() => {
      const eventArr = { event: 'Top Right Corner' };
      const localObj = new LocalTracking();
      localObj.push(eventArr);
    });
  });
});
